// extracted by mini-css-extract-plugin
export var cardLayout = "_88-1";
export var paginationContainer = "_88-0";